module.exports = __webpack_public_path__ + "img/Roche_Logo.1614852e.png";